import { render, staticRenderFns } from "./CloseTab.vue?vue&type=template&id=7cddd00f&scoped=true&"
import script from "./CloseTab.vue?vue&type=script&lang=ts&"
export * from "./CloseTab.vue?vue&type=script&lang=ts&"
import style0 from "./CloseTab.vue?vue&type=style&index=0&id=7cddd00f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cddd00f",
  null
  
)

export default component.exports